import { Injectable } from '@angular/core';

import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import * as _ from 'lodash';

import { LocationGroup } from '@core/interfaces';
import { MutationCreateLocationGroupGQL, MutationUpdateLocationGroupGQL } from './api/mutations.service';
import { QueryLocationGroupGQL, QueryLocationsGroupsPaginatedGQL } from './api/queries.service';

interface SubjectResult {
  items: LocationGroup[];
  totalCount: number;
  filtered: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LocationsGroupsService {

  constructor(
    private locationsGroupsPaginatedGQL: QueryLocationsGroupsPaginatedGQL,
    private locationGroupGQL: QueryLocationGroupGQL,
    private mutationCreateLocationGroupGQL: MutationCreateLocationGroupGQL,
    private mutationUpdateLocationGroupGQL: MutationUpdateLocationGroupGQL,
    private fuseProgressBarService: FuseProgressBarService
  ) { }

  async getLocationsGroups({ where, options }): Promise<SubjectResult> {
    this.fuseProgressBarService.show();

    return this.locationsGroupsPaginatedGQL.fetch({
      where: where,
      orderBy: options.orderBy,
      limit: options.limit,
      offset: options.offset
    })
      .toPromise()
      .then(({ data }) => {
        this.fuseProgressBarService.hide();

        return {
          items: data.locationsGroups.items,
          totalCount: data.locationsGroups.totalCount,
          filtered: Boolean(!!where.name_contains || where.archived !== false)
        };
      });

  }

  save(locationGroupId, locationGroup): Promise<any> {
    if (locationGroupId) {
      return this.update(locationGroupId, locationGroup);
    }

    return this.create(locationGroup);
  }

  async create(locationGroup): Promise<any> {
    this.fuseProgressBarService.show();
    return this.mutationCreateLocationGroupGQL.mutate({
      input: locationGroup
    }).toPromise();
  }

  async update(locationGroupId, locationGroup): Promise<any> {
    this.fuseProgressBarService.show();
    return this.mutationUpdateLocationGroupGQL.mutate({
      id: locationGroupId,
      input: locationGroup
    }).toPromise();
  }

  async getLocationGroup(id?: string): Promise<LocationGroup> {
    if (id) {
      this.fuseProgressBarService.show();
      return this.locationGroupGQL.fetch({ id })
        .toPromise()
        .then(({ data }) => {
          this.fuseProgressBarService.hide();
          return data.locationGroup as LocationGroup;
        });
    }
    return null;
  }
}
